import { useMutation } from '@tanstack/react-query';
import { I18n } from '@aws-amplify/core';
import { message } from 'antd';
import Api from '@/services/api';
import type { BaseContext } from '@/types';

export type UpdateCommentRequest = BaseContext & {
	comment: string;
	file_id: string;
	id: string;
};

type UpdateCommentResponse = any;

async function updateComment(payload: UpdateCommentRequest): Promise<UpdateCommentResponse> {
	const url = `ergonomic-tool/owas/report/${payload.id}/comment`;
	const { data } = await Api.put<any>(url, payload);
	return data;
}

export const useUpdateComment = () => {
	return useMutation((body: UpdateCommentRequest) => updateComment(body), {
		onSuccess: () => {
			message.success(I18n.get('Comment updated successfully'));
		},
		onError: () => {
			message.error(I18n.get('Fail to save the comments'));
		}
	});
};
